import { Injectable } from '@angular/core';
import { DriverStatus } from 'src/app/@models/entities/driver';
import { RiderApprovalStatus, RiderStatus } from 'src/app/@models/entities/rider';
import { RequestStatus } from 'src/app/@models/entities/request';
import { PaymentRequestStatus } from 'src/app/@models/entities/payment-request';
import { TransactionStatus } from 'src/app/@models/entities/driver-transaction';
import { AgencyApprovalStatus, Status, SubscriptionStatus } from 'src/app/@models/enums/enums';

@Injectable({
  providedIn: 'root'
})
export class TagColorService {

  constructor() { }

  driver(value: DriverStatus) {
    switch (value) {
      case (DriverStatus.Blocked):
      case (DriverStatus.HardReject):
        return 'error';

      case (DriverStatus.Online):
        return 'processing';

      case (DriverStatus.InService):
        return 'success'

      case (DriverStatus.WaitingDocuments):
      case (DriverStatus.SoftReject):
      case (DriverStatus.Offline):
        return 'default';

      case (DriverStatus.PendingApproval):
        return 'warning';
    }
  }
  rider(value: RiderStatus) {
    switch (value) {
      case (RiderStatus.Disabled):
        return 'error';
      case (RiderStatus.Enabled):
        return 'success';
      case (RiderStatus.Blocked):
          return 'error';
      default:
          return 'warning';
      
    }
  }
  request(value: RequestStatus) {
    switch (value) {
      case (RequestStatus.Expired):
        return 'default';

      case (RequestStatus.RiderCanceled):
      case (RequestStatus.DriverCanceled):
      case (RequestStatus.NotFound):
      case (RequestStatus.NoCloseFound):
        return 'error';

      case (RequestStatus.Booked):
        return 'warning';

      case (RequestStatus.Finished):
        return 'success';

      default:
        return 'processing';
    }
  }

  transactionStatus(status: TransactionStatus) {
    switch (status) {
      case (TransactionStatus.Processing):
        return 'processing';

      case(TransactionStatus.Done):
        return 'success';

      case (TransactionStatus.Rejected):
        return 'error';

      case (TransactionStatus.Canceled):
        return 'warning';

    }
  }

  requestBadge(value: RequestStatus) {
    switch (value) {
      case (RequestStatus.RiderCanceled):
      case (RequestStatus.DriverCanceled):
      case (RequestStatus.NotFound):
      case (RequestStatus.NoCloseFound):
      case (RequestStatus.Expired):
        return 'error';

      case (RequestStatus.Booked):
      case (RequestStatus.Started):
      case (RequestStatus.WaitingForPostPay):
      case (RequestStatus.WaitingForReview):
        return 'processing';

      case (RequestStatus.Finished):
        return 'success';

      default:
        return 'default';
    }

  }

  boolean(value: boolean) {
    return value ? 'success' : 'error';
  }

  paymentRequest(value: PaymentRequestStatus) {
    switch(value) {
      case(PaymentRequestStatus.Paid):
        return 'success';
      case(PaymentRequestStatus.Pending):
        return 'warning';
      case(PaymentRequestStatus.Rejected):
        return 'error';
    }
  }

  subscriptionStatus(value: SubscriptionStatus) {
    switch(value) {
      case(SubscriptionStatus.Active):
        return 'success';
      case(SubscriptionStatus.Paused):
        return 'warning';
      case(SubscriptionStatus.Canceled):
        return 'error';
    }
  }

  disputeStatus(value: Status) {
    switch(value) {
      case(Status.Open):
        return 'error';
      case(Status.Closed):
        return 'warning';
      case(Status.Resolved):
        return 'success';
    }
  }


  agencyApprovalStatus(status: AgencyApprovalStatus) {
    switch (status) {
      case (AgencyApprovalStatus.Pending):
        return 'processing';

      case(AgencyApprovalStatus.Approved):
        return 'success';

      case (AgencyApprovalStatus.Rejected):
        return 'error';

      case (AgencyApprovalStatus.Under_Consideration):
        return 'warning';

    }
  }

  riderApprovalStatus(status: RiderApprovalStatus) {
    switch (status) {
      case (RiderApprovalStatus.WaitingDocuments):
        return 'processing';

      case(RiderApprovalStatus.Approved):
        return 'success';

      case (RiderApprovalStatus.Rejected):
        return 'error';

      case (RiderApprovalStatus.PendingApproval):
        return 'warning';

    }
  }
}
